<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("whMonitoringDocumentPhotoDetail") }}
                  </h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.created_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.updated_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row"></div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Status</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="status"
                          :value="
                            forms?.status ? forms.status.toUpperCase() : ''
                          "
                          readonly
                        />
                        <div v-if="errors.name">
                          <div
                            v-for="error in errors.name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Zip Queue Status</label
                        >
                      </div>
                      <div class="col-lg-7">
                        <input
                          type="text"
                          class="form-control"
                          id="status"
                          :value="
                            forms?.zip_job_status
                              ? forms.zip_job_status.toUpperCase()
                              : ''
                          "
                          readonly
                        />
                        <div v-if="errors.name">
                          <div
                            v-for="error in errors.name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-auto">
                        <a
                          :class="
                            !forms?.zip_url ? 'btn-danger' : 'btn-success'
                          "
                          class="btn"
                          :href="forms?.zip_url ?? '#'"
                          ><i class="mdi mdi-download"></i
                        ></a>
                      </div>
                      <div class="col-lg-auto">
                        <!-- <a
                          :class="
                            !forms?.zip_url ? 'btn-danger' : 'btn-success'
                          "
                          class="btn"
                          :href="forms?.zip_url ?? '#'"
                          ><i class="mdi mdi-content-copy"></i
                        ></a> -->
                        <button
                          class="btn btn-warning"
                          :disabled="!forms.zip_url"
                          @click.prevent="copyText(forms?.zip_url)"
                        >
                          <i class="mdi mdi-content-copy"></i>
                        </button>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("fulfillment") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="warehouse_id"
                          :placeholder="$t('fulfillment')"
                          :value="
                            forms.warehouse_id + ' - ' + forms?.warehouse?.name
                          "
                          readonly
                        />
                        <div v-if="errors.warehouse_id">
                          <div
                            v-for="error in errors.warehouse_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("customer") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="usernameTxt"
                          :placeholder="$t('customer')"
                          :value="
                            forms.customer_id + ' - ' + forms.customer?.name
                          "
                          readonly
                        />
                        <div v-if="errors.username">
                          <div
                            v-for="error in errors.username"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ forms.type }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="usernameTxt"
                          :placeholder="$t('customer')"
                          :value="forms.reference_no"
                          readonly
                        />
                        <div v-if="errors.username">
                          <div
                            v-for="error in errors.username"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("driver_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="driver_name"
                          :placeholder="$t('driver_name')"
                          v-model="forms.driver_name"
                          readonly
                        />
                        <div v-if="errors.driver_name">
                          <div
                            v-for="error in errors.driver_name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("vehicle_no") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="vehicle_no"
                          :placeholder="$t('vehicle_no')"
                          v-model="forms.vehicle_no"
                          readonly
                        />
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Images</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <div class="row">
                          <div
                            class="col-auto d-flex flex-column align-items-center mb-2"
                            v-for="(image, index) in images"
                            :key="index"
                          >
                            <img
                              :src="image.src"
                              class="img-thumbnail"
                              style="
                                cursor: pointer;
                                width: auto;
                                height: 100px;
                              "
                              @click="
                                visible = true;
                                imageIndex = index;
                              "
                            />
                            <!-- <div class="overlay">
                              <i class="fas fa-search-plus magnifier-icon"></i>
                            </div> -->
                            <div class="row">
                              <div class="col">
                                <button
                                  v-show="permision_role.method_delete"
                                  type="button"
                                  class="btn btn-xs btn-icon btn-danger mt-2"
                                  @click="deleteImage(image.document_detail_id)"
                                >
                                  <i class="mdi mdi-delete"></i>
                                </button>
                              </div>
                              <div class="col">
                                <button
                                  v-show="permision_role.method_read"
                                  type="button"
                                  class="btn btn-xs btn-icon btn-success mt-2"
                                  @click="downloadImage(image)"
                                >
                                  <i class="mdi mdi-download"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <vue-easy-lightbox
                      escDisabled
                      moveDisabled
                      :visible="visible"
                      :imgs="images"
                      :index="imageIndex"
                      @hide="handleHide"
                    ></vue-easy-lightbox>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_update"
                        class="btn btn-primary me-2 text-white fw-bolder btn-icon-text float-end"
                        @click="downloadZip(forms.document_header_id)"
                      >
                        <i class="mdi mdi-folder-download"></i>
                        Download Zip
                      </a>
                      <a
                        v-if="permision_role.method_update"
                        class="btn btn-warning me-2 text-white fw-bolder btn-icon-text float-end"
                        @click="addZipJob(forms.document_header_id)"
                      >
                        <i class="mdi mdi-zip-box"></i>
                        Add Zip Queue
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import VueEasyLightbox from "vue-easy-lightbox";
import { getAuthToken } from "@/middleware/auth";
export default {
  name: "DocumentPhotoDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    VueEasyLightbox,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      fetchRole: [],
      fetchCompany: [],
      permision_role: [],
      forms: [],
      images: [],
      visible: false,
      imageIndex: 0,
    };
  },
  watch: {},
  methods: {
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$swal({
          title: "Success",
          icon: "success",
        });
      } catch ($e) {
        this.$swal({
          title: "Can't Copy",
          icon: "error",
        });
      }
    },
    addZipJob(document_header_id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("addZipJobQueue"),
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Yes & Compress",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#5cd672",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        this.isLoading = true;

        let url = null;
        let body = {};
        if (result.value) {
          url =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/request-zip/" +
            document_header_id;
        } else if (result.isDenied) {
          url =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/request-zip/" +
            document_header_id;
          body = {
            is_compress: "Y",
          };
        } else {
          this.isLoading = false;
        }

        if (url) {
          this.$http
            .post(url, body)
            .then((response) => {
              if (response.data.status == 200) {
                this.$swal({
                  icon: "success",
                  title: "Success",
                  text:
                    "Pending Queue Job : " + response.data.datas.pending_job,
                });
                this.loadData(this.forms.document_header_id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }

              this.loadItems();
            })
            .catch((error) => {
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            })
            .finally(() => this.loading());
        }
      });
    },
    handleHide() {
      this.visible = false;
    },
    resetForm() {
      this.forms.name = "";
      this.forms.username = "";
      this.forms.password = "";
      this.forms.email = "";
      this.forms.company_id = "";
      this.forms.role_id = "";
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    backForm() {
      window.location.href = "/wh-monitoring/document-photo";
    },
    // async downloadZip(id) {
    //   const baseURI =
    //     this.$settings.endpointWhMonitoring +
    //     "v1/document-header/download-zip/" +
    //     id;
    //   let error;

    //   // let res =  await this.$http
    //   //   .post(baseURI, {
    //   //     responseType: "arraybuffer",
    //   //   })
    //   //   .then((response) => {
    //   //     if (response.status == 200) {

    //   //       // Get Filename from server
    //   //       const contentDisposition = response.headers["content-disposition"];
    //   //       const filenameMatch = contentDisposition.match(
    //   //         /filename\*?=["']?([^"';]+)["']?/i
    //   //       );
    //   //       let filename = "test.zip"; // Default filename if not found
    //   //       if (filenameMatch && filenameMatch[1]) {
    //   //         filename = decodeURIComponent(filenameMatch[1]); // Decode URI components for special characters
    //   //       }

    //   //       const fileURL = window.URL.createObjectURL(new Blob([response.data],{type:'application/zip'}));
    //   //       var fileLink = document.createElement("a");

    //   //       fileLink.href = fileURL;
    //   //       fileLink.setAttribute("download", filename);
    //   //       document.body.appendChild(fileLink);
    //   //       fileLink.click();
    //   //       fileLink.remove(); // Clean up the link element
    //   //       window.URL.revokeObjectURL(fileURL);
    //   //     }
    //   //     // var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //   //     // var fileLink = document.createElement("a");

    //   //     // fileLink.href = fileURL;
    //   //     // fileLink.setAttribute("download", file_name);
    //   //     // document.body.appendChild(fileLink);
    //   //     // fileLink.click();
    //   //     this.fade(false);
    //   //   });

    //   // console.log(res);
    //   // var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
    //   // var file_name = "download_" + CurrentDate + ".xlsx";
    //   try {
    //     const response = await this.$http.post(baseURI, {
    //       responseType: "arraybuffer",

    //     });

    //     // Get the filename from the 'Content-Disposition' header if available
    //     const contentDisposition = response.headers["content-disposition"];
    //     let filename = "download.zip"; // Default filename
    //     if (contentDisposition) {
    //       const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    //       if (filenameMatch && filenameMatch[1]) {
    //         filename = filenameMatch[1];
    //       }
    //     }

    //     // Create a URL for the Blob received from Axios
    //     let blob = new Blob([response.data], {type:'application/zip'});
    //     console.log(blob.size)
    //     console.log(filename)
    //     const url = window.URL.createObjectURL(blob);

    //     // Create a temporary anchor element
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = 'test.bin'; // Set the download attribute
    //     document.body.appendChild(a); // Append to body
    //     a.click(); // Programmatically click
    //     a.remove(); // Remove after click

    //     // Revoke the Blob URL to free up resources
    //     // window.URL.revokeObjectURL(url);

    //     console.log(response);
    //   } catch (err) {
    //     // Axios error object might have different structure than native fetch error
    //     console.error("Error downloading ZIP file:", err);
    //     if (err.response) {
    //       // Server responded with a status code outside 2xx range
    //       error.value = `Failed to download file: Server responded with status ${err.response.status}`;
    //     } else if (err.request) {
    //       // The request was made but no response was received
    //       error.value =
    //         "Failed to download file: No response received from server.";
    //     } else {
    //       // Something else happened while setting up the request
    //       error.value = `Failed to download file: ${err.message}`;
    //     }
    //   }c

    //   return error;
    // },
    async downloadImage(img) {
      const url =
        this.$settings.endpointWhMonitoring +
        "v1/document-header/download-detail/" +
        this.forms.document_header_id +
        "/" +
        img.document_detail_id;

      this.$http
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(res.data);
          const link = document.createElement("a");
          link.href = url;
          link.download = img.title;
          link.click();
        });
    },
    downloadZip: async function (id) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/document-header/download-zip/" +
        id;
      this.isLoading = true;
      try {
        // Use fetch to make the request
        const response = await fetch(baseURI, {
          headers: {
            // "Content-Type": "application/zip",
            Authorization: "Bearer " + getAuthToken(),
          },
          method: "POST",
        });

        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
          const json = await response.json();
          // console.log(json);
          this.resultError(json.errors);
          // this.error(json.message || "Unknown error");
          this.loading();
          return;
        }

        // IMPORTANT: Fetch does NOT reject on HTTP error statuses (like 404, 500).
        // You must manually check response.ok.
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response.status} - ${response.statusText}`,
          );
        }

        // Get the filename from the 'Content-Disposition' header if available
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = "download.zip"; // Default filename
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        // Get the response body as a Blob (binary large object)
        const blob = await response.blob();

        // --- DEBUGGING: Log the blob size vs Content-Length from header ---
        // console.log("Blob size (bytes):", blob.size);
        // console.log("Content-Length header:", response.headers.get('Content-Length'));
        // --- END DEBUGGING ---

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger download
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // Set the download attribute
        document.body.appendChild(a); // Append to body
        a.click(); // Programmatically click
        a.remove(); // Remove after click

        // Revoke the Blob URL to free up resources
        window.URL.revokeObjectURL(url);
        this.loading();
      } catch (err) {
        this.error(err)
        // This catch block will handle network errors or explicit errors thrown above
        // console.error("Error downloading ZIP file:", err);
        this.loading();
      }
    },
    deleteImage(id) {
      // console.log(id)

      this.$swal({
        title: this.$t("areYouSure"),
        text: status,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/delete-detail/" +
            this.forms.document_header_id +
            "/" +
            id;
          this.$http
            .delete(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(this.forms.document_header_id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    loadData(id) {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/document-header/detail/" + id;
      this.isLoading = true;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.images = [];
          this.forms = response.data.datas;
          this.isLoading = false;

          if (this.forms?.details.length > 0) {
            this.forms.details.forEach((item) => {
              this.images.push({
                src: item.url,
                title: item.file_name,
                document_detail_id: item.document_detail_id,
              });
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.loading();
        });
    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          // let params = this.$onBehind(this.$route.params.id);
          // let formData = new FormData();
          // formData.append("name", this.forms.name);
          // formData.append("username", this.forms.username);
          // formData.append("password", this.forms.password);
          // formData.append("email", this.forms.email);
          // formData.append("company_id", this.forms.company_id);
          // formData.append("role_id", this.forms.role_id);
          // formData.append("status", 'active');

          const baseURI = this.$settings.endPoint + "users/" + this.forms.id;
          this.$http
            .patch(baseURI, this.forms, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.id);
                window.location.href = "/user-access/detail/" + params;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller ==
            "WhMonitoringDocumentHeaderController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);

    this.cek_message(this.$route.query.status, this.$route.query.msg);
    this.fetchIt();
    this.loadData(params[0]);
  },
};
</script>
<style scoped></style>
